export default "__VITE_PUBLIC_ASSET__4c1eba08__"